export default (config) => ({
    activeTab: config.activeTab,
    tabs: config.tabs,
    init() {
        const splitHash = window.location.hash.slice(1).split("/");
        const initialTab = splitHash[0];

        this.activeTab =
            this.tabs.indexOf(initialTab) > -1 ? initialTab : this.tabs[0];

        if (splitHash[1]) {
            const scrollTo = document.getElementById(
                window.location.hash.substr(1)
            );
            if (scrollTo) {
                // wait 300 ms for the tab to be shown before scrolling
                setTimeout(() => {
                    scrollTo.scrollIntoView({ behavior: "smooth", block: "center" });
                }
                , 300);
            }
        }
    },
    setActiveTab(tab) {
        this.activeTab = tab;
    },
    focusPreviousTab(event) {
        if (event.key === 'ArrowLeft') {
            const currentIndex = this.tabs.indexOf(this.activeTab);
            const previousTab = this.tabs[currentIndex === 0 ? this.tabs.length - 1 : currentIndex - 1];
            this.activeTab = previousTab;
            document.querySelector(`#tab-${previousTab}`).focus();
            event.stopPropagation();
            event.preventDefault();
        }
    },
    focusNextTab(event) {
        if (event.key === 'ArrowRight') {
            const currentIndex = this.tabs.indexOf(this.activeTab);
            const nextTab = this.tabs[currentIndex === this.tabs.length - 1 ? 0 : currentIndex + 1];
            this.activeTab = nextTab;
            document.querySelector(`#tab-${nextTab}`).focus();
            event.stopPropagation();
            event.preventDefault();
        }
    },
    focusFirstTab(event) {
        if (event.key === 'Home') {
            this.activeTab = this.tabs[0];
            document.querySelector(`#tab-${this.activeTab}`).focus();
            event.stopPropagation();
            event.preventDefault();
        }
    },
    focusLastTab(event) {
        if (event.key === 'End') {
            this.activeTab = this.tabs[this.tabs.length - 1];
            document.querySelector(`#tab-${this.activeTab}`).focus();
            event.stopPropagation();
            event.preventDefault();
        }
    },
});
